import useSessions from 'data/firestore/session/useCollection';
import { query, where } from 'firebase/firestore';

const useCalls = (agentId: string) => {
    const { data: calls, isLoading } = useSessions({
        listQueryFn: (ref) => {
            const today = new Date();
            const thirtyDaysAgo = new Date(today.getTime() - 30 * 24 * 60 * 60 * 1000);
            return query(
                ref,
                where('agentId', '==', agentId),
                where('createdAt', '>=', thirtyDaysAgo),
            );
        },
    });
    return {
        calls,
        isLoading,
    };
};

export default useCalls;
